import { faCalendarPlus, faChevronDown, faPortrait, faTags, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import React, { useEffect, useState } from 'react';
import { Button, Input, Popover, PopoverBody, PopoverHeader, UncontrolledTooltip } from 'reactstrap';
import style from './AdminWaitlistedCandidates.style';
import './AdminWaitlistedCandidates.style.css';
import ManagePopover from './ManagePopover/ManagePopover';
import Loading from 'Body/Statuses/Loading';
import Swal from 'sweetalert2';
import { RouterPrompt } from 'Body/RezRATE/Common/RouterPrompt/RouterPrompt';
import { popoverModifiers } from 'enums';

// Initialize Day.js plugins
dayjs.extend(utc);
dayjs.extend(timezone);

let closedManagePopover = false;
const AdminWaitlistedCandidates = ({
  candidates = [],
  interviewDate,
  getCandidates,
  showRegistered,
  setShowRegistered,
  isFetchingCandidates,
  setActiveTab,
  windowWidth,
}) => {
  const [showFilterPopover, setShowFilterPopover] = useState({});
  const [date, setDate] = useState();
  const [hasChanges, setHasChanges] = useState(false);
  const [myShowRegistered, setMyShowRegistered] = useState(false);
  const [candidatesToDisplay, setCandidatesToDisplay] = useState([]);

  const widthToSwitchToMobile = 980;

  useEffect(() => {
    if (interviewDate) {
      setDate(interviewDate);
    }
  }, [interviewDate]);

  useEffect(() => {
    setMyShowRegistered(showRegistered);
    setCandidatesToDisplay(
      candidates.filter((candidate) => {
        const { InterviewDatepk_InterviewDate } = candidate;
        return (!showRegistered && InterviewDatepk_InterviewDate == null) || showRegistered;
      }),
    );
  }, [showRegistered, candidates]);

  const renderManagePopover = (row) => {
    return (
      <Popover
        flip={false}
        popperClassName="commsManagePopover"
        isOpen={showFilterPopover[row.pk_Candidate]}
        trigger="legacy"
        target={`manage_btn_${row.pk_Candidate}`}
        modifiers={popoverModifiers}
        toggle={(e) => {
          const { target } = e;
          const { className = '' } = target;

          if (className.includes && (className.includes('swal2') || className.includes('manage_save_notes'))) {
            return;
          }
          const newShowFilterPopover = { ...showFilterPopover };
          const newValue = !newShowFilterPopover[row.pk_Candidate];

          if (!newValue && hasChanges && !closedManagePopover) {
            Swal.fire({
              title: 'Are you sure?',
              text: 'You have unsaved changes!',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, close!',
            }).then((result) => {
              if (result.isConfirmed) {
                setHasChanges(false);
                newShowFilterPopover[row.pk_Candidate] = newValue;
                setShowFilterPopover(newShowFilterPopover);
                closedManagePopover = true;
              }
            });

            return;
          }

          newShowFilterPopover[row.pk_Candidate] = newValue;

          if (newValue) {
            closedManagePopover = false;
          } else {
            closedManagePopover = true;
          }
          setShowFilterPopover(newShowFilterPopover);
        }}
      >
        <PopoverHeader>
          <div style={style.spacedBetweenRow}>
            <div style={{ width: '100%' }}>Waitlist Actions</div>
            <div>
              <FontAwesomeIcon
                icon={faTimesCircle}
                style={style.clickable}
                onClick={(e) => {
                  e.stopPropagation();
                  const newShowFilterPopover = { ...showFilterPopover };
                  newShowFilterPopover[row.pk_Candidate] = false;

                  setShowFilterPopover(newShowFilterPopover);
                }}
              />
            </div>
          </div>
        </PopoverHeader>
        <PopoverBody>
          <ManagePopover
            setHasChanges={setHasChanges}
            setActiveTab={setActiveTab}
            candidate={row}
            hidePopover={() => {
              const newShowFilterPopover = { ...showFilterPopover };
              newShowFilterPopover[row.pk_Candidate] = false;

              setShowFilterPopover(newShowFilterPopover);
            }}
            interviewDate={date}
            getCandidates={getCandidates}
          />
        </PopoverBody>
      </Popover>
    );
  };

  const getDatesStrings = (c) => {
    const { interviewDates = [], InterviewDatepk_InterviewDate } = c;

    const dateStrings = [];

    interviewDates
      .sort((a, b) => {
        return a.PreferenceOrder - b.PreferenceOrder;
      })
      .forEach((d) => {
        const { DateOfInterview, Label, StartTime, pk_InterviewDate } = d;
        dateStrings.push(
          `${
            DateOfInterview && StartTime
              ? dayjs.tz(`${DateOfInterview} ${StartTime}`, null).format('MMM DD, YYYY')
              : 'No Date'
          } ${Label ? `(${Label})` : ''} ${pk_InterviewDate === InterviewDatepk_InterviewDate ? '[REGISTERED]' : ''}`,
        );
      });

    return dateStrings;
  };

  return (
    <div style={style.simpleRow}>
      <div style={{ display: 'flex', flexDirection: 'column', marginTop: 10, width: '100%' }}>
        <RouterPrompt
          hasChanges={hasChanges}
          okLabel={'Discard Changes'}
          onOk={() => {
            setHasChanges(false);
            return true;
          }}
        />
        <div style={style.title}>Waitlisted Candidates: {candidatesToDisplay.length}</div>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
          {' '}
          <Input
            id="showRegisterSwitch"
            type="switch"
            checked={showRegistered}
            label="Show Registered"
            onClick={(e) => {
              console.log('onCLick!!');
              setShowRegistered(!showRegistered);
              // e.stopPropagation();
              // setShowRegistered(!e.target.checked);
            }}
            onChange={(e) => {}}
          />
        </div>
        <div style={style.mainContainer}>
          <div style={{ ...style.column, minWidth: '100%' }}>
            {candidatesToDisplay && !isFetchingCandidates ? (
              candidatesToDisplay.map((candidate, i) => {
                let backgroundColor = '#c97200';
                const { CandidateResponseToInvitationTimestamp } = candidate;
                const timeToDisplay = CandidateResponseToInvitationTimestamp
                  ? dayjs(CandidateResponseToInvitationTimestamp)
                      .tz(dayjs.tz.guess())
                      .format('MM-DD-YYYY hh:mm A')
                  : '---';
                if (i % 2 === 0) {
                  backgroundColor = '#fd9801';
                }

                const {
                  FirstName,
                  InterviewDateDateOfInterview,
                  InterviewDateLabel,
                  LastName,
                  CandidateSubHeading,
                  NumberOfWaitlistedDates,
                  PhotoUrl,
                  Tags = [],
                  InterviewDatepk_InterviewDate,
                  WaitlistPreferenceOrder,
                } = candidate;

                let tags = 'None';
                if (Tags) {
                  Tags.forEach((tag) => {
                    if (tag.Tag) {
                      if (tags === 'None') {
                        tags = `${tag.Tag}`;
                      } else {
                        tags += `, ${tag.Tag}`;
                      }
                    }
                  });
                }

                let candidateName = `---`;
                if (candidate && LastName && FirstName) {
                  candidateName = `${candidate.LastName}, ${candidate.FirstName}`;
                } else if (candidate && candidate.LastName) {
                  candidateName = `${candidate.LastName}`;
                } else if (candidate && candidate.FirstName) {
                  candidateName = ` ${candidate.FirstName}`;
                }
                return (
                  <div style={{ ...style.itemRow, backgroundColor, color: 'white' }}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        width: windowWidth < widthToSwitchToMobile ? 80 : 'auto',
                      }}
                    >
                      {PhotoUrl ? (
                        <img src={PhotoUrl} width={80} style={style.imgPlaceHolder} />
                      ) : (
                        <FontAwesomeIcon style={style.imgPlaceHolder} icon={faPortrait} />
                      )}
                      {windowWidth < widthToSwitchToMobile && (
                        <Button id={`manage_btn_${candidate.pk_Candidate}`} style={{ color: 'white', marginTop: 8 }}>
                          <FontAwesomeIcon icon={faChevronDown} />
                          <UncontrolledTooltip
                            placement="top"
                            flip={false}
                            target={`manage_btn_${candidate.pk_Candidate}`}
                            modifiers={popoverModifiers}
                          >
                            Actions
                          </UncontrolledTooltip>
                        </Button>
                      )}
                    </div>
                    <div style={{ ...style.column, width: '100%' }}>
                      <div style={style.candidateName}>{candidateName} </div>
                      <div style={{ ...style.medicalSchool, fontWeight: 'bold' }}>
                        {' '}
                        <b>Responded: </b> {` `}
                        {timeToDisplay}
                      </div>
                      <div style={{ ...style.medicalSchool, fontWeight: 'bold' }}>
                        {' '}
                        {InterviewDateDateOfInterview
                          ? `Current Interview Session: ${dayjs(InterviewDateDateOfInterview).format('MMM DD, YYYY')}`
                          : ''}
                        {`${InterviewDateLabel ? ` (${InterviewDateLabel})` : ''}`}
                      </div>
                      <div style={style.medicalSchool}>{CandidateSubHeading || '---'}</div>
                      <div style={style.medicalSchool} id={`waitlisted_${candidate.pk_Candidate}`}>
                        #
                        {WaitlistPreferenceOrder != null
                          ? `${WaitlistPreferenceOrder + 1} Choice`
                          : 'Registered by Admin'}{' '}
                        | {NumberOfWaitlistedDates != null ? NumberOfWaitlistedDates : '0'} Selected
                        {NumberOfWaitlistedDates > 0 ? (
                          <UncontrolledTooltip
                            placement="top"
                            flip={false}
                            target={`waitlisted_${candidate.pk_Candidate}`}
                            modifiers={popoverModifiers}
                          >
                            {getDatesStrings(candidate).map((d, i) => {
                              return (
                                <div style={{ textAlign: 'left', width: '100%' }}>
                                  {i + 1}. {d}
                                </div>
                              );
                            })}
                          </UncontrolledTooltip>
                        ) : null}
                      </div>
                      <div style={style.medicalSchool}>
                        <FontAwesomeIcon icon={faTags} style={{ marginRight: 10 }} />
                        <span>{tags}</span>
                      </div>
                    </div>

                    {windowWidth >= widthToSwitchToMobile && (
                      <div style={{ ...style.column, width: 80 }}>
                        <Button id={`manage_btn_${candidate.pk_Candidate}`} style={{ color: 'white' }}>
                          <FontAwesomeIcon icon={faChevronDown} />
                          <UncontrolledTooltip
                            placement="top"
                            flip={false}
                            target={`manage_btn_${candidate.pk_Candidate}`}
                            modifiers={popoverModifiers}
                          >
                            Actions
                          </UncontrolledTooltip>
                        </Button>
                        {renderManagePopover(candidate)}
                      </div>
                    )}
                    {windowWidth < widthToSwitchToMobile && renderManagePopover(candidate)}
                  </div>
                );
              })
            ) : isFetchingCandidates ? (
              <div style={{ marginTop: 100 }}>
                <Loading options={{ Label: 'Fetching candidates. .  .' }} />
              </div>
            ) : (
              <div>No Candidates</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminWaitlistedCandidates;
